// extracted by mini-css-extract-plugin
export default {"wait_layer_active":"Wait_wait_layer_active__yKoma","wait_layer_hidden":"Wait_wait_layer_hidden__wCx9f","loading":"Wait_loading__Pl9OS","rotate_img":"Wait_rotate_img__O6tqn"};